import { onMounted, onUnmounted } from 'vue' // 用于review panel验证码页面的通信

// 用于review panel验证码页面的通信
export default () => {
  const handleReviewMessage = (e: MessageEvent) => {
    const eventData = e.data
    if (!eventData.type || !/^review/.test(eventData.type)) return
    let data
    switch (eventData.type) {
      case 'review-panel-close': {
        const el = document.querySelector('#shield-app > div > div > span')
        el?.dispatchEvent(new Event('click'))
        break
      }
      default:
        break
    }
    e.source?.postMessage({ type: `${eventData.type}:response`, data }, e.origin)
  }

  onMounted(() => window.addEventListener('message', handleReviewMessage))

  onUnmounted(() => window.removeEventListener('message', handleReviewMessage))
}
